import type { SVGProps } from "react";
const SvgSquareArrowUp01Sharp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.25}
      d="M2.083 10c0-3.732 0-5.598 1.16-6.757 1.16-1.16 3.025-1.16 6.757-1.16s5.598 0 6.757 1.16c1.16 1.16 1.16 3.025 1.16 6.757s0 5.598-1.16 6.757c-1.16 1.16-3.025 1.16-6.757 1.16s-5.598 0-6.757-1.16c-1.16-1.159-1.16-3.025-1.16-6.757Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M14.167 11.667 10.52 8.644c-.25-.207-.375-.31-.521-.31s-.271.103-.52.31l-3.647 3.023"
    />
  </svg>
);
export default SvgSquareArrowUp01Sharp;
